function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { gs } from '@domain-group/fe-co-allhomes-analytics';
var EventProvider = 'fe-server-allhomes';
var earlyAccessDetails = property => {
  var _property$listing, _property$address;
  return (property === null || property === void 0 ? void 0 : (_property$listing = property.listing) === null || _property$listing === void 0 ? void 0 : _property$listing.type) === 'SALES_EARLY_ACCESS' ? {
    PreMarketStatus: 'Yes',
    PreMarketAddress: property === null || property === void 0 ? void 0 : (_property$address = property.address) === null || _property$address === void 0 ? void 0 : _property$address.formattedFull
  } : {
    PreMarketStatus: 'No'
  };
};
var getMemberType = user => (user === null || user === void 0 ? void 0 : user.type) === 'authenticated' ? 'member' : 'visitor';
var memberDetails = user => _objectSpread({
  MembershipType: getMemberType(user)
}, (user === null || user === void 0 ? void 0 : user.id) && {
  UserId: user === null || user === void 0 ? void 0 : user.id
});
var agentDetails = property => {
  var _property$listing2, _property$agencies$;
  if ((property === null || property === void 0 ? void 0 : (_property$listing2 = property.listing) === null || _property$listing2 === void 0 ? void 0 : _property$listing2.type) === 'SHARE_RESIDENTIAL') {
    return {};
  }
  var agentIds = property.agents.filter(agent => agent.agentId).map(agent => agent.agentId);
  var agencyId = (_property$agencies$ = property.agencies[0]) === null || _property$agencies$ === void 0 ? void 0 : _property$agencies$.agencyId;
  return _objectSpread(_objectSpread({}, agentIds.length && {
    AgentId: agentIds.join(',')
  }), agencyId && {
    AgencyId: "".concat(agencyId)
  });
};
var onlineAuctionDetails = property => {
  var _property$listing3, _property$listing3$ev;
  return {
    OnlineAuctionAvailable: property !== null && property !== void 0 && (_property$listing3 = property.listing) !== null && _property$listing3 !== void 0 && (_property$listing3$ev = _property$listing3.events) !== null && _property$listing3$ev !== void 0 && _property$listing3$ev.some(event => event.hasOnlineAuction) ? 'Other' : 'None'
  };
};
var listingEntityDetails = property => {
  var _property$listing4, _property$listing5;
  return {
    SourceEntityId: (property === null || property === void 0 ? void 0 : (_property$listing4 = property.listing) === null || _property$listing4 === void 0 ? void 0 : _property$listing4.id) == null ? '' : "".concat(property === null || property === void 0 ? void 0 : (_property$listing5 = property.listing) === null || _property$listing5 === void 0 ? void 0 : _property$listing5.id),
    SourceEntityType: 'Listing'
  };
};
var targetEntityDetails = property => {
  var _property$agencies$2, _property$agencies$3;
  return {
    TargetEntityId: ((_property$agencies$2 = property.agencies[0]) === null || _property$agencies$2 === void 0 ? void 0 : _property$agencies$2.agencyId) == null ? '' : "".concat((_property$agencies$3 = property.agencies[0]) === null || _property$agencies$3 === void 0 ? void 0 : _property$agencies$3.agencyId),
    TargetEntityType: 'Agency'
  };
};
export var BaseEmailEnquiryFormClick = data => gs.event('EmailEnquiryFormClick', '^2.0.0')(_objectSpread({
  EventProvider,
  EventCategory: 'takeaction.intent',
  EventSource: 'PropertyDetails'
}, data));
export var BaseAgencyDetailsView = data => gs.event('AgencyDetailsView', '^2.0.0')(_objectSpread({
  EventProvider,
  EventCategory: 'takeaction.intent',
  EventSource: 'PropertyDetails'
}, data));
export var AdvertView = _ref => {
  var property = _ref.property,
    user = _ref.user;
  return gs.AdvertView(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, listingEntityDetails(property)), onlineAuctionDetails(property)), agentDetails(property)), memberDetails(user)), earlyAccessDetails(property)));
};
export var EmailEnquiryFormClick = _ref2 => {
  var property = _ref2.property,
    user = _ref2.user,
    EventSourceDetails = _ref2.EventSourceDetails;
  return BaseEmailEnquiryFormClick(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    EventSourceDetails
  }, listingEntityDetails(property)), onlineAuctionDetails(property)), agentDetails(property)), memberDetails(user)), earlyAccessDetails(property)));
};
export var AgencyDetailsView = _ref3 => {
  var property = _ref3.property,
    user = _ref3.user,
    EventSourceDetails = _ref3.EventSourceDetails;
  return BaseAgencyDetailsView(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    EventSourceDetails
  }, listingEntityDetails(property)), agentDetails(property)), memberDetails(user)), targetEntityDetails(property)));
};